import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MapPin } from "lucide-react";

export function DistanceControl({ distAddr, setDistAddr, distRadius, setDistRadius, onApply }) {
  return (
    <div className="bg-white border border-border rounded-sm p-4" data-testid="tenant-distance-control">
      <div className="flex items-center gap-2 mb-3">
        <MapPin className="w-4 h-4 text-primary" />
        <span className="font-display font-semibold">Search distance</span>
        <span className="text-sm text-muted-foreground">Only see properties within range of your address.</span>
      </div>
      <div className="flex flex-wrap gap-3 items-end">
        <div className="flex-1 min-w-[220px]">
          <Label className="text-xs">Your address</Label>
          <Input data-testid="tenant-dist-address" value={distAddr} onChange={(e) => setDistAddr(e.target.value)} placeholder="123 Main St, Austin, TX" />
        </div>
        <div>
          <Label className="text-xs">Within</Label>
          <select data-testid="tenant-dist-radius" value={distRadius} onChange={(e) => setDistRadius(e.target.value)}
            className="w-32 h-10 rounded-sm border border-input bg-background px-3 text-sm">
            {[5, 10, 25, 50, 100].map((m) => (<option key={m} value={m}>{m} miles</option>))}
          </select>
        </div>
        <Button data-testid="tenant-dist-apply" onClick={onApply}>Apply</Button>
      </div>
    </div>
  );
}
